import gql from 'graphql-tag'

export const UpsertFavorite = gql`
  mutation UpsertFavorite($data: FavoriteInput!) {
    upsertFavorite(data: $data) {
      _id
    }
  }
`
